<template>
  <BaseModal
    modal-id="file-edit"
    :is-open="isOpen"
    :save-state="isSaving ? 'saving' : 'fresh'"
    :header-text="$t('Edit file')"
    :confirm-button-text="$t('Save')"
    @save="saveFile"
    @cancel="$emit('canceled')"
  >
    <div class="m-t-10 form-group">
      <label>{{ $t('File name') }}</label>

      <div class="input-group">
        <input v-model="form.name" class="form-control" />

        <div class="input-group-addon">.{{ file.extension }}</div>
      </div>
    </div>

    <div class="form-group">
      <label>{{ $t('Title') }}</label>

      <div class="input-group tw-w-full">
        <input v-model="form.title" class="form-control" />
      </div>
    </div>

    <div v-if="showTags" class="form-group">
      <label>{{ $t('Tags') }}</label>

      <TypeSelect
        name="tags"
        tag-type="fileTags"
        :options-in="availableTags"
        :locale-in="language"
        :selected-in="form.tags"
        :placeholder="$t('Eg. Contracts, Terms, etc...')"
        :show-typesuggestions="false"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
import TypeSelect from '@/components/TypeSelect.vue'

export default {
  components: { BaseModal, TypeSelect },
  props: {
    file: {
      type: Object,
      default: () => ({}),
    },

    availableTags: {
      type: Array,
      required: true,
    },

    isSaving: {
      type: Boolean,
      required: false,
    },

    isOpen: {
      type: Boolean,
      required: false,
    },

    showTags: {
      type: Boolean,
      required: false,
      default: false,
    },

    showTitle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      form: {
        name: '',
        title: '',
        tags: [],
      },
      language: currentLanguageSelected,
    }
  },

  created() {
    this.form.name = this.file.name.replace(/\.[^/.]+$/, '')
    this.form.title = this.file.title ?? ''
    this.form.tags = this.file.tags.map((tag) => tag.name)
  },

  methods: {
    async saveFile() {
      this.$emit('save', [this.file.localId, this.form.name, this.form.tags, this.form.title])
      this.$emit('updated')
    },
  },
}
</script>
